import React, {useCallback, useImperativeHandle, useMemo, useRef, useState} from 'react';
import { Button, Checkbox, Icon, Image, Modal, Space } from 'udesk-ui';
import { TaskRemainingTime } from '../task-submit-button';
import './index.less';
import UdeskLocales from 'UdeskLocales';

export default  React.memo((props: any) => {
    const {
        record,
        task,
        next,
        current,
        taskDetail,
        submitTaskHandle,
        isLastPage,
        isStartTask,
        isFullscreen,
        requestFullscreen,
        exitFullscreen,
    }= props;
    const {modalRef, openModal} = useModal();
    const autoFullScreen = useCallback(() => {
        if (isFullscreen) {
            exitFullscreen();
        } else {
            requestFullscreen();
        }
    }, [exitFullscreen, isFullscreen, requestFullscreen]);

    return (
        <div className='ppt-content'>
            {
                isFullscreen && (
                    <div className='ppt-content-title'>
                        <span>{task?.taskName}</span>
                        <TaskRemainingTime {...{
                            record, taskDetail, isStartTask, submitTaskHandle
                        }}/>
                    </div>
                )
            }
            <Image
                preview={false}
                placeholder={true}
                src={current?.downloadPath}
                fallback="data:image/png;base64,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"
            />

            <Space>
                {
                    isLastPage ? null : <Button onClick={openModal} icon={<Icon type='RightCircleOutlined' antdIcon={true}/>}>{/* 下一页 */}{UdeskLocales['current'].pages.coach.learningCenter.components.ppt.index.nextPage}</Button>
                }
                
                <Button 
                    onClick={autoFullScreen}
                    icon={
                        <Icon 
                            type={isFullscreen ? 'FullscreenExitOutlined' : 'FullscreenOutlined'} 
                            antdIcon={true}
                        />
                    } 
                />
            </Space>
            <MessageModal ref={modalRef} next= {next} isStartTask={isStartTask}/>
        </div>
    );
});


type RefType = {
    open: () => void;
}

const useModal = () => {
    const modalRef = useRef<RefType>(null);

    const openModal = useCallback(() => {
        modalRef.current?.open();
    }, []);

    return {
        modalRef,
        openModal,
    };
};

const MessageModal = React.forwardRef<RefType, any>((props, ref) => {
    const {next, isStartTask, visible = false} = props;
    const [isVisible, setIsVisible] = useState(visible);
    const [checked, setChecked] = useState(false);
    const [isNeverVisible, setIsNeverVisible] = useState(false);

    useImperativeHandle(ref, () => {
        return {
            open() {
                let data = isStartTask;
                if (isNeverVisible) {
                    data = false;
                }
                if (!data) {
                    next();
                }
                setIsVisible(data);
            }
        };
    });

    const isShow = useMemo(() => {
        if (isNeverVisible) {
            return false;
        }
        if (isStartTask) {
            return isVisible;
        }
        return false;
    }, [isNeverVisible, isStartTask, isVisible]);

    const submitHandle = useCallback(() => {
        if (checked) {
            setIsNeverVisible(true);
        }
        next();
        setIsVisible(false);
    }, [checked, next]);

    const cancelHandle = useCallback(() => {
        setIsVisible(false);
    },[]);

    return (
        <Modal 
            wrapClassName='task-exercise-message-modal'
            zIndex={9999}
            title={/* 提示 */UdeskLocales['current'].pages.coach.learningCenter.components.ppt.index.tips}
            cancelText={/* 继续当前页 */UdeskLocales['current'].pages.coach.learningCenter.components.ppt.index.continueWithCurrentPage}
            okText={/* 进入下一页 */UdeskLocales['current'].pages.coach.learningCenter.components.ppt.index.goToTheNextPage}
            maskClosable={false}
            getContainer={false}
            visible={isShow} 
            onOk={submitHandle} 
            onCancel={cancelHandle}
        >
            <div>{/* 进入下一页后将不能再返回上一页，请确认当前页讲解完整后再跳转 */}{UdeskLocales['current'].pages.coach.learningCenter.components.ppt.index.afterEnteringTheNextPageYouWillNotBeAbleToReturnToThePreviousPagePleaseConfirmThatTheExplanationOnTheCurrentPageIsCompleteBeforeJumpingToTheNextPage}</div>
            <div className='not-prompted'>
                <Checkbox value={checked} onChange={(e) => setChecked(e.target.checked)}>{/* 点击下一页将不在弹出此提示 */}{UdeskLocales['current'].pages.coach.learningCenter.components.ppt.index.clickingOnTheNextPageWillNoLongerCauseThisPromptToPopUp}</Checkbox>
            </div>
        </Modal>
    );
});

